import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Route, useLocation } from 'react-router-dom';
import { Layout, PageHeader, notification, Spin } from 'antd';
import Sider from '../components/Sider';
import MenuButton from '../components/MenuButton';
import Alert from '../components/alerts/Alerts';
import ContractList from './contracts_list/ContractList';
import ContractDetail from './contract_detail/ContractDetail';
import RefreshToken from '../components/RefreshToken';
import { RESOURCE } from '../config/constants/alerts';
import { USER_SHOW } from '../state/user/types';
import EditContract from './admin_edit_contract/EditContract';
import { OBJECTION_MSG_ADMIN_KEY } from '../config/constants/forms';
import Profile from './admin/Profile';
import CouponView from './coupons/CouponView';
import Dashboard from './dasboard/Dashboard';
import PropTypes from 'prop-types';

/**
 * Component that returns the main page of SPA app
 * @component
 * @returns {Element} all view components
 */
const Home = ({ getUser, isLoaded }) => {

  const { Content } = Layout;
  const { pathname } = useLocation();
  const [siderVisible, setSiderVisible] = useState(true);
  const [spinning, setSpinning] = useState(true);

  useEffect(() => { getUser('login'); }, []);
  useEffect(() => {
    if (!pathname.includes('/contracts/admin/edit_contract/')) {
      notification.close(OBJECTION_MSG_ADMIN_KEY);
      setSiderVisible(true);
    } else {
      setSiderVisible(false);
    }
  }, [pathname]);
  useEffect(() => { if (isLoaded) { setSpinning(false); } }, [isLoaded]);

  const Extra = () => (
    <div className='d-flex align-items-center'>
      <MenuButton key="menu_button" />
    </div>
  );


  const headerStyle = {
    position: 'fixed',
    zIndex: 3,
    width: '100%',
    paddingLeft: '250px'
  };

  const contentStyle = {
    margin: '24px 16px',
    overflow: 'hidden',
    paddingTop: '80px'
  };

  return (
    <Layout>
      {spinning ? (<Spin className="spin-centered" tip="Cargando..."></Spin>) : <>
        <RefreshToken />
        {siderVisible &&
          <Sider />
        }
        <Layout key="layout">
          <PageHeader
            key="pagare_header"
            className="site-page-header"
            extra={[
              <Extra key='header_1' />
            ]}
            style={headerStyle}
          >
          </PageHeader>
          <Layout key="content" className={pathname.includes('admin') ? 'layout-admin' : 'layout-content'}>
            <Content style={contentStyle}>
              <Alert />
              <Route exact strict path="/contracts" component={ContractList} />
              <Route exact strict path="/contracts/contract_detail/:params" component={ContractDetail} />
              <Route exact strict path="/account/profile" component={Profile} />
              <Route exact strict path="/coupons" component={CouponView} />
              <Route exact strict path="/dashboard" component={Dashboard} />
              <Route exact strict path="/contracts/admin/edit_contract/:params" component={EditContract} />
            </Content>
          </Layout>
        </Layout>
      </>}
    </Layout>
  );
};

Home.propTypes = {
  getUser: PropTypes.func.isRequired,
  isLoaded: PropTypes.bool.isRequired,
};

const data = (state) => ({
  isLoaded: state.user.isLoaded,
});

const action = (dispatch) => ({
  getUser: () => dispatch({ type: USER_SHOW, payload: RESOURCE.GET_USER_DATA }),
});

export default connect(data, action)(Home);